import React, { PureComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { Text } from 'mdlkit';
import AffiliationSearch from './AffiliationSearch';
import InsuranceDetail from './InsuranceDetail';
import Wizard from '../../Wizard';

export const StyledText = styled(Text)<{ htmlFor?: string }>`
  align-self: self-start;
  padding-top: ${({ theme }) => theme.space.xs + theme.space.sm}px;
`;

interface Props {
  onSubmit: (values: any) => void;
  disableSubmit?: boolean;
  setShowSkipLink(boolean): void;
}

class InsuranceForm extends PureComponent<Props> {
  state = {
    hideNav: false,
    hideNextPage: null,
  };

  setHideNav = hideNav => {
    this.setState({ hideNav });
  };

  setHideNextPage = hideNextPage => {
    this.setState({ hideNextPage });
  };

  render(): ReactNode {
    const { hideNav, hideNextPage } = this.state;
    const { onSubmit, disableSubmit, setShowSkipLink } = this.props;

    return (
      <Wizard
        onSubmit={onSubmit}
        disableSubmit={disableSubmit}
        hideNav={hideNav}
        spellCheck={false}
      >
        <Wizard.Page>
          <AffiliationSearch
            setHideNav={this.setHideNav}
            setHideNextPage={this.setHideNextPage}
            setShowSkipLink={setShowSkipLink}
          />
        </Wizard.Page>

        {!hideNextPage ? <InsuranceDetail /> : null}
      </Wizard>
    );
  }
}

export default InsuranceForm;
